/*** IMPORTS FROM imports-loader ***/
(function() {

require('./build/scripts/ng-map.js');
module.exports = 'ngMap';

/*** EXPORTS FROM exports-loader ***/
module.exports = window.angular;
}.call(window));